import type { Device } from '../../../../types/Device';
import type { NodeTypeConfig } from './node-types';

export interface NodeAccountAvailability {
	required: boolean;
	available: boolean;
	label: string;
	count: number;
}

const PRESENCE_DEVICE_TYPES = new Set(['S4SN-0U61X', 'S4SN-0A61X']);

export function getNodeAccountAvailability(
	node: Pick<NodeTypeConfig, 'deviceRequirement'>,
	context: {
		devices?: Record<string, Device> | Device[];
		virtualComponentCount?: number;
	},
): NodeAccountAvailability {
	const requirement = node.deviceRequirement;
	if (!requirement) return { required: false, available: true, label: '', count: 0 };
	if (requirement === 'virtual-component') {
		const count = Number(context.virtualComponentCount || 0);
		return {
			required: true,
			available: count > 0,
			count,
			label: count
				? `${count} virtual ${count === 1 ? 'component' : 'components'} available`
				: 'No virtual components in this account',
		};
	}
	const devices = Array.isArray(context.devices)
		? context.devices
		: Object.values(context.devices || {});
	const matches =
		requirement === 'presence'
			? devices.filter((device) => PRESENCE_DEVICE_TYPES.has(device.type))
			: devices.filter((device) => Number(device.gen) >= 2);
	const noun = requirement === 'presence' ? 'Presence sensor' : 'Gen2+ device';
	return {
		required: true,
		available: matches.length > 0,
		count: matches.length,
		label: matches.length
			? matches.length === 1
				? `Available: ${matches[0].name || noun}`
				: `${matches.length} compatible ${noun.toLowerCase()}s`
			: `No compatible ${noun.toLowerCase()} in this account`,
	};
}
